import React from 'react'

const ZoomOutIcon = ({color = 'currentColor', width = 20, height = 20, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M4.16667 10H15.8333"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default ZoomOutIcon
